import { useState } from "react";
import { useInputField } from "@edreamsodigeo/prisma-design-system";
const useCustomField = ({
  id,
  disabled,
  errors,
  initialValue = "",
  trackEvent
}) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState("");
  const validate = value => {
    if (value === "") {
      setError(errors.EMPTY.key);
      trackEvent(errors.EMPTY.track);
      return false;
    } else if (!value.match(errors.FORMAT.validator)) {
      setError(errors.FORMAT.key);
      trackEvent(errors.FORMAT.track);
      return false;
    } else {
      setError("");
      return true;
    }
  };
  return {
    field: useInputField({
      value,
      onChange: event => {
        setValue(event.currentTarget.value);
        setError("");
      },
      onBlur: () => validate(value),
      id,
      disabled,
      type: "text",
      onReset: () => setValue(initialValue),
      validate: () => !error
    }),
    error
  };
};
export default useCustomField;